import api from './api';

export function getCurrentThread() {
    return api.get('/ai-tutor/thread');
}

export function getMessages(threadId) {
    return api.get(`/ai-tutor/threads/${threadId}/messages`);
}

export function sendMessage(threadId, message) {
    return api.post(`/ai-tutor/threads/${threadId}/messages`, { message });
}

export function getAiSettings() {
    return api.get('/admin/ai-settings');
}

export function updateAiSettings(data) {
    return api.put('/admin/ai-settings', data);
}

/**
 * Stream a message using fetch + ReadableStream.
 * Calls onChunk(chunk) for each SSE data chunk and onDone() when finished.
 */
export async function streamMessage(threadId, message, { onChunk, onDone, onError }) {
    const token = localStorage.getItem('token');
    const url = `/api/ai-tutor/threads/${threadId}/stream?message=${encodeURIComponent(message)}`;

    let finished = false;

    const finish = () => {
        if (finished) return;
        finished = true;
        onDone();
    };

    const fail = (message) => {
        if (finished) return;
        finished = true;
        onError(message);
    };

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'text/event-stream',
                Authorization: token ? `Bearer ${token}` : '',
            },
        });

        if (!response.ok) {
            throw new Error('Stream request failed');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n\n');
            buffer = lines.pop() || '';

            for (const block of lines) {
                const dataLine = block.trim().split('\n').find(line => line.startsWith('data:'));
                if (!dataLine) continue;

                const payload = dataLine.replace(/^data:\s*/, '');
                try {
                    const parsed = JSON.parse(payload);
                    if (parsed.chunk) {
                        onChunk(parsed.chunk);
                    }
                    if (parsed.done) {
                        finish();
                    }
                    if (parsed.error) {
                        fail(parsed.error);
                    }
                } catch (e) {
                    // ignore malformed payload
                }
            }
        }

        finish();
    } catch (err) {
        fail(err.message || 'Streaming xatolik');
    }
}
